import { Autocomplete, Divider, Grid, ListItemText, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import contactStyles from '../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { ACTION_TYPE_NAME, emptyContactListObj } from '../../flowBuilderConstants'
import { ContactContext, ContactContextPayload } from '../../../../../context/contactContext'
import { getCampaignContactListResponse } from '../../../../../models/axiosModel'
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import { UserContext, UserContextPayload } from '../../../../../context/userContext'
import GlobalTooltip from '../../../../utility/tooltip/globalTooltip'
import { primaryColor } from '../../../../../utils/colors'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext'
import { isCurrentViewVersionPublished } from '../../utilityFunctions'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext'
import { filterAutocompleteOptionsWithException, formatString } from '../../../../../utils/constants'
import { useNavigate } from 'react-router-dom'
import { filterOutArchivedContactLists } from '../../../contacts/contactConstant'

const SaveAndRemoveContactComponent = (props: any) => {
    
    const { actionData, stepAction } = props;
    const { campaignContactListData, getCampaignContactListApi, setFlagAddNewListDialog } = useContext(ContactContext) as ContactContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const navigate = useNavigate();

    const getContactListApi = async () => {
        setFlagLoading((prev) =>({ ...prev, flagRoundLoader: true }));
        const res = await getCampaignContactListApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) =>({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!campaignContactListData){
            getContactListApi();
        }
    }, [])

    const getOptionsOfContactList = (): getCampaignContactListResponse[] => {
        if(campaignContactListData){
            return [...filterOutArchivedContactLists(campaignContactListData), emptyContactListObj];
        }
        return [];
    }

    const onClickOfAddNewList = () => {
        navigate(`${window.location.origin}/contacts`);
        setFlagAddNewListDialog(true);
    }

    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: getCampaignContactListResponse): React.ReactNode => {
        if (option.contact_list_id == -1 && option.contact_list_name == "New List") {
            return (
                <ul className={contactStyles.newTagNameUlElement}>
                    <Divider className={contactStyles.newTagDivider} />
                    <li {...props} className={contactStyles.newOptionListItem} onClick={() => onClickOfAddNewList()}>
                        <AddIcon />
                        <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                            New List
                        </Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.contact_list_id}>
                <Grid container>
                    <ListItemText primary={option.contact_list_name} className={styles.listItemsStyle} />
                </Grid>
            </li>
        )
    }

    const checkDisableContactListOption = (option: getCampaignContactListResponse) => {
        const node = nodes?.find((node: any) => node?.id == stepAction?.chatbot_step_id);
        if(node){
            const action = node?.data?.find((action: any) => (action?.chatbot_step_action_id != stepAction?.chatbot_step_action_id && (action?.action_type?.action_type_name == ACTION_TYPE_NAME["SAVE_CONTACT"] || action?.action_type?.action_type_name == ACTION_TYPE_NAME["REMOVE_CONTACT"])));
            if(action){
                if(action?.action_data?.action_contact_list_id == option?.contact_list_id){
                    return true;
                }
            }
        }
        return false;
    }

    const getValueOfContactList = () => {
        if(campaignContactListData){
            return campaignContactListData?.find((list) => (actionData?.action_contact_list_id)?.toString() == (list.contact_list_id)?.toString()) ?? null
        } 
        return null;
    }

    const onChangeOfContactList = (value: getCampaignContactListResponse | null) => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
            {
                action_contact_list_id: value ? value.contact_list_id : null,
                contact_list_name: value ? value?.contact_list_name : "",
            },
            {
                updateType: "editExistingStepAction"
            }
        ); 

        if(value){
            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                {
                    action_contact_list_id: value ? value.contact_list_id : null,
                    contact_list_name: value ? value?.contact_list_name : "",
                },
                {
                    updateType: "editExistingStepAction"
                }
            )
        }
    }
    
    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                {formatString(stepAction?.action_type?.action_type_name ?? "")}
                            </Grid>
                            <Grid item>
                                <Grid container className={globalStyles.displayFlex} gap={"5px"} flexWrap={"nowrap"}>
                                    <Grid item xs={11.5}>
                                        <Autocomplete
                                            className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                            options={getOptionsOfContactList()}
                                            value={getValueOfContactList()}
                                            getOptionLabel={(option: getCampaignContactListResponse) => option.contact_list_name}
                                            filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "contact_list_name", "contact_list_id")}
                                            onChange={(e, value) => onChangeOfContactList(value)}
                                            ListboxProps={{ className: contactStyles.listBoxCustomStyle }}
                                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: getCampaignContactListResponse) => { return renderOptions(props, option); }}
                                            getOptionDisabled={(option) => checkDisableContactListOption(option)}
                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                            clearIcon={null}
                                            renderInput={params => {
                                                const { InputProps, ...restParams } = params;
                                                const { startAdornment, ...restInputProps } = InputProps;
                                                return (
                                                    <TextField
                                                        {...restParams}
                                                        placeholder='Select Contact List'
                                                        InputProps={{
                                                            ...restInputProps,
                                                            startAdornment: (
                                                                <div className={contactStyles.selectTagTextField}>
                                                                    {startAdornment}
                                                                </div>
                                                            ),
                                                        }}
                                                    />
                                                );
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        <GlobalTooltip
                                            title="Fetch latest contact list"
                                            placement='top'
                                            arrow
                                        >
                                            <RefreshIcon className={styles.refreshContactListIcon} onClick={() => getContactListApi()} />
                                        </GlobalTooltip>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SaveAndRemoveContactComponent
